module.exports = __webpack_public_path__ + "static/media/baza_foto_1_B.c09255e2.png";